<template>
	<div>
		<h1>404</h1>
		<h2>Page Not Found</h2>
	</div>
</template>
<script>
export default {

}
</script>
<style type="text/css">
	div{
		display: flex;
		height: 100vh;
		flex-direction: column;
		justify-content: center;
	}
	h1{
		font-size: 60px;
		font-weight: 600;
		text-align: center;
		margin: 0 0 16px 0;
	}
	h2{
		text-align: center;
		margin: 0 0 16px 0;
	}
</style>